// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"07ae1bd7","360":"0659cd92","457":"aa4f33a1","478":"9e1e8b9d","518":"569e87ce","791":"31d6cfe0","880":"7d7406c5"}[chunkId] + ".chunk.css";
};